import { useStaticQuery, graphql } from 'gatsby'
import React, { useState, useContext, useEffect } from 'react'
import Image from '../image';
import Link from '../link';
import { breakpoints, collectionHierarchy, collectionNestedPaths, orderCollections } from '../../utils/helpers';
import ArrowSvg from '-!svg-react-loader!../../assets/images/menu-arrow.svg';
import BackArrow from '-!svg-react-loader!../../assets/images/icons/back-arrow.svg'
import Arrow from '-!svg-react-loader!../../assets/images/arrow.svg'
import ThemeContext from '../../context/theme-context';

const ShopDropdown = ({ shopMenuOpen, setShopMenuOpen }) => {
  const [activeCollection, setActiveCollection] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const { setOverlayIsOpen } = useContext(ThemeContext);

  useEffect(() => {
    const scale = () => {
      setIsMobile(window.innerWidth < breakpoints.lg);
    }

    window.addEventListener('resize', scale);
    window.dispatchEvent(new Event('resize'));

    return () => {
      window.removeEventListener('resize', scale)
    }
  }, [])

  const data = useStaticQuery(graphql`
    query {
      savings: wordpressMenuLocation(slug: {eq: "shop_savings"}) {
        menuData {
          name
          items {
            ID
            title
            url
          }
        }
      }
      popular: wordpressMenuLocation(slug: {eq: "shop_popular"}) {
        menuData {
          name
          items {
            ID
            title
            url
          }
        }
      }
      allShopifyCollection {
        nodes {
          id
          title
          handle
          products {
            id
          }
          mainCol: metafield(namespace: "collection", key: "collection_ismain") {
            value
          }
          collectionType: metafield(namespace: "arena", key: "collectionType") {
            value
          }
          subCollections: metafield(namespace: "collection", key: "collection_subs") {
            value
          }
          image {
            src
          }
        }
      }
    }
  `)

  const allCollections = collectionNestedPaths(data.allShopifyCollection.nodes);
  const topLevelCollections = orderCollections(collectionHierarchy(data.allShopifyCollection.nodes)
    .filter(collection => collection.products.length > 0 && collection.mainCol));

  if(isMobile) {
    // Add savings item as first item, with two subs, based on data.savings.menuData
    const savingsItem = {
      id: 'savings',
      title: 'Savings',
      handle: 'savings',
      subs: data.savings.menuData.items.map(item => ({
        id: item.ID,
        title: item.title,
        handle: item.url.split('/').pop()
      }))
    }
    topLevelCollections.unshift(savingsItem);
  }

  const getCollectionPath = (collection) => {
    const match = allCollections.find(col => col.id === collection.id);
    return match ? `/collection/${match.handle}` : `/collection/${collection.handle}`;
  }

  const MenuList = ({menu, name}) => {
    return (
      menu.items.length > 0 && (
        <div className={`shop-dropdown__menulist shop-dropdown__${name}`}>
          <h3 className="shop-dropdown__title">{menu.name}</h3>
          <ul className="shop-dropdown__menulist__items shop-dropdown__menu">
            {menu.items.map(item => (
              <li key={item.ID}><Link to={item.url}>{item.title}</Link></li>
            ))}
          </ul>
        </div>
      )
    )
  }

  return (<>
    <div className={`shop-dropdown${shopMenuOpen ? ' open' : ''}`}
      onMouseEnter={() => {
        setOverlayIsOpen(true);
      }}
      onMouseLeave={() => {
        setOverlayIsOpen(false);
      }}
      role="presentation"
      >
      <div className="shop-dropdown__inner Container">

        <div className="shop-dropdown__initial">
          {!isMobile && (
            <div className="shop-dropdown__left">
              <MenuList menu={data.popular.menuData} name="popular" />
              <MenuList menu={data.savings.menuData} name="savings" />
            </div>
          )}
          <div className="shop-dropdown__main">
            {isMobile && (
              <button
                className="shop-dropdown__back"
                onClick={() => setShopMenuOpen(false)}
              ><Arrow />&nbsp;Back</button>
            )}
            <h3 className="shop-dropdown__title">Shop</h3>
            <nav className="shop-dropdown__nav">
              <ul className="shop-dropdown__nav__menu shop-dropdown__menu">
                <li><Link to="/shop">View All Products</Link></li>
                {topLevelCollections.map(collection => (
                  <li key={collection.id} className={collection.id === 'savings' ? 'savings' : null}>
                    <a
                      href={`/collection/${collection.handle}`}
                      onClick={e => {
                        e.preventDefault();
                        isMobile && activeCollection.id === collection.id ? setActiveCollection(false) : setActiveCollection(collection);
                      }}
                    >{collection.title}&nbsp;<span><ArrowSvg /></span></a>

                    {isMobile && activeCollection.id === collection.id && (
                      <ul className="shop-dropdown__submenu">
                        {collection.id !== 'savings' && (
                          <li><Link to={`/collection/${collection.handle}`}>
                            View All
                          </Link></li>
                        )}
                        {collection.subs.map(item => (
                          <li key={item.id}>
                            <Link to={getCollectionPath(item)}>
                              {item.title}&nbsp;<span><ArrowSvg /></span>
                            </Link>
                          </li>
                        ))}
                      </ul>
                    )}
                  </li>
                ))}
              </ul>
            </nav>
          </div>
        </div>

        {!isMobile && (
          <div className="shop-dropdown__sub__wrap">
            {activeCollection && (
              <div className="shop-dropdown__sub">
                <div className="shop-dropdown__sub__inner">

                  <div className="shop-dropdown__sub__back">
                    <button onClick={() => setActiveCollection(false)}>
                      <BackArrow />&nbsp;Back
                    </button>
                  </div>

                  {activeCollection.subs?.length > 0 && (
                    <nav className="shop-dropdown__sub__nav">
                      <Link
                        to={getCollectionPath(activeCollection)}
                        className="shop-dropdown__sub__title__link"
                      >
                        <h3 className="shop-dropdown__title">
                          {activeCollection.title}
                        </h3>
                      </Link>
                      <ul className="shop-dropdown__sub__nav__menu shop-dropdown__menu">
                        <li><Link to={`/collection/${activeCollection.handle}`}>
                          View All
                        </Link></li>
                        {activeCollection.subs.map(item => (
                          <li key={item.id}>
                            <Link to={getCollectionPath(item)}>
                              {item.title}&nbsp;<span><ArrowSvg /></span>
                            </Link>
                          </li>
                        ))}
                      </ul>
                    </nav>
                  )}

                  {activeCollection.image && (
                    <div className="shop-dropdown__sub__featured">
                      <Link
                        to={getCollectionPath(activeCollection)}
                        className="shop-dropdown__sub__featured__link"
                      >
                        <Image
                          source={activeCollection.image.src}
                          imgClass="shop-dropdown__sub__featured__thumbnail"
                        />
                        <span className="shop-dropdown__sub__featured__title">
                          {activeCollection.title}
                        </span>
                      </Link>
                    </div>
                  )}

                </div>
              </div>
            )}
          </div>
        )}

      </div>
    </div>
  </>)
}

export default ShopDropdown